import Error from '../../components/Error';

const NotFoundPage = () => <Error message="Page non trouvée." />;

export default NotFoundPage;
